"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ErrorOutlineOutlined = _interopRequireDefault(require("@mui/icons-material/ErrorOutlineOutlined"));
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ToastContent = _ref => {
  let {
    type,
    title,
    message
  } = _ref;
  const getStyles = () => {
    let backgroundColor = '';
    let color = '';
    let IconComponent = null;
    switch (type) {
      case _constants.alertTypes.error:
        backgroundColor = _constants.colors['main-color-cl-21'];
        color = _constants.colors['main-color-cl-08'];
        IconComponent = _ErrorOutlineOutlined.default;
        break;
      default:
        backgroundColor = _constants.colors['main-color-cl-08'];
        color = _constants.colors['main-color-cl-01'];
    }
    return {
      backgroundColor,
      color,
      IconComponent
    };
  };
  const getDefaultMessage = () => {
    switch (type) {
      case _constants.alertTypes.error:
        return 'Something went wrong';
      default:
        return 'Success';
    }
  };
  const {
    backgroundColor,
    color,
    IconComponent
  } = getStyles();
  const defaultMessage = getDefaultMessage();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      backgroundColor,
      display: 'flex',
      gap: '12px'
    }
  }, IconComponent && /*#__PURE__*/_react.default.createElement(IconComponent, {
    sx: {
      width: '22px',
      height: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      backgroundColor
    }
  }, title && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      color
    }
  }, title), message && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      color
    }
  }, message), !title && !message && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      color
    }
  }, defaultMessage)));
};
exports.ToastContent = ToastContent;
ToastContent.propTypes = {
  type: _propTypes.default.string,
  title: _propTypes.default.string,
  message: _propTypes.default.string
};